/* __next_internal_client_entry_do_not_use__ default auto */ import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import Logo from '@/app/img/logo-500x500.png';
import { Button, IconButton, TextField } from "__barrel_optimize__?names=Button,IconButton,TextField!=!@mui/material";
import SignInWithGoogle from './SignInWithGoogle';
import toast from 'react-hot-toast';
import { motion } from 'framer-motion';
import { signIn } from '@/lib/firebase/client-auth';
import { useRouter } from 'next/navigation';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
function SignIn() {
    const [email, setEmail] = React.useState('');
    const [emailFound, setEmailFound] = React.useState(false);
    const [password, setPassword] = React.useState('');
    const [showPassword, setShowPassword] = React.useState(false);
    const [loading, setLoading] = React.useState(false);
    const [isNewUser, setIsNewUser] = React.useState(false);
    const router = useRouter();
    const handleAccountLookup = async ()=>{
        setLoading(true);
        if (!email || email.trim() === '') {
            setLoading(false);
            toast.error('Please enter your email');
            return;
        }
        try {
            const response = await fetch("/api/user?email=".concat(email.trim()), {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            if (!response.ok) {
                const data = await response.json();
                throw new Error(data.error || 'Failed to check email');
            }
            const data = await response.json();
            if (data && data.email) {
                setEmailFound(true);
                if (data.metadata.lastSignInTime === null) {
                    setIsNewUser(true);
                    const response = await fetch('/api/user/password', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            email: email.trim()
                        })
                    });
                    if (!response.ok) {
                        const data = await response.json();
                        throw new Error(data.message || 'Failed to send activation email');
                    }
                }
            } else {
                setEmailFound(false);
                toast.error('No account found with that email');
            }
        } catch (error) {
            console.error(error);
            toast.error(error.message || 'An error occurred while checking your email');
        } finally{
            setLoading(false);
        }
    };
    const handleLogin = async (e)=>{
        e.preventDefault();
        setLoading(true);
        try {
            if (!email || email.trim() === '') {
                setLoading(false);
                toast.error('Please enter your email');
                return;
            }
            if (!password || password.trim() === '') {
                setLoading(false);
                toast.error('Please enter your password');
                return;
            }
            const result = await signIn(email.trim(), password);
            if (result.success) {
                var _result_user_type;
                const userType = (_result_user_type = result.user_type) === null || _result_user_type === void 0 ? void 0 : _result_user_type.toLowerCase();
                router.replace("/".concat(userType));
            } else {
                toast.error('Invalid email or password');
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
            toast.error(error instanceof Error ? error.message : 'An error occurred during sign in');
        }
    };
    return /*#__PURE__*/ _jsx("div", {
        className: "max-w-sm mx-auto w-full",
        children: /*#__PURE__*/ _jsxs(motion.div, {
            initial: {
                opacity: 0,
                scale: 0.95
            },
            animate: {
                opacity: 1,
                scale: 1
            },
            transition: {
                duration: 0.3
            },
            className: "p-5 md:p-10 bg-white shadow rounded-lg",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "flex justify-center",
                    children: /*#__PURE__*/ _jsx("img", {
                        src: Logo.src,
                        alt: "AutoVINsights Logo",
                        className: "w-16"
                    })
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "mt-10",
                    children: [
                        /*#__PURE__*/ _jsxs("form", {
                            className: "flex flex-col gap-5",
                            onSubmit: handleLogin,
                            children: [
                                /*#__PURE__*/ _jsx(TextField, {
                                    value: email,
                                    type: "email",
                                    onChange: (e)=>setEmail(e.target.value),
                                    label: "Email",
                                    name: "email",
                                    variant: "outlined",
                                    fullWidth: true
                                }),
                                !emailFound && /*#__PURE__*/ _jsx(Button, {
                                    type: "button",
                                    variant: "contained",
                                    fullWidth: true,
                                    loading: loading,
                                    onClick: ()=>handleAccountLookup().then(()=>setLoading(false)),
                                    children: "Continue"
                                }),
                                emailFound && /*#__PURE__*/ _jsxs(_Fragment, {
                                    children: [
                                        isNewUser && /*#__PURE__*/ _jsx("p", {
                                            className: "text-sm text-neutral-600 text-center",
                                            children: "It looks like you have never signed in before. We have sent an activation link to your email."
                                        }),
                                        /*#__PURE__*/ _jsx(TextField, {
                                            value: password,
                                            onChange: (e)=>setPassword(e.target.value),
                                            label: "Password",
                                            name: "password",
                                            variant: "outlined",
                                            fullWidth: true,
                                            type: showPassword ? 'text' : 'password',
                                            slotProps: {
                                                input: {
                                                    endAdornment: /*#__PURE__*/ _jsx(IconButton, {
                                                        size: "small",
                                                        onClick: ()=>setShowPassword(!showPassword),
                                                        edge: "end",
                                                        children: showPassword ? /*#__PURE__*/ _jsx(VisibilityOffIcon, {}) : /*#__PURE__*/ _jsx(VisibilityIcon, {})
                                                    })
                                                }
                                            }
                                        }),
                                        /*#__PURE__*/ _jsx(Button, {
                                            type: "submit",
                                            variant: "contained",
                                            fullWidth: true,
                                            loading: loading,
                                            children: "Sign In"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(SignInWithGoogle, {})
                    ]
                })
            ]
        })
    });
}
export default SignIn;
